<template>
  <b-container fluid class="thankyou">
    <h3 class="mt-2">Bentornato su GiustUp!</h3>
    <p class="mt-5">Codice fiscale: <b>{{ codFisc }}</b></p>

    <!-- LOGIN -->
    <div v-if="showLogin">
      <p class="mt-2">Effettua l'accesso con il social network associato:</p>

      <b-button class="btn-login google" v-if="scelta == 'Google'" @click="login('Google')">
        <font-awesome-icon :icon="['fab', 'google']" />&nbsp;&nbsp;&nbsp;&nbsp;
        Google
      </b-button>

      <p v-if="scelta == 'Facebook'">Facebook non è più supportato. Si prega di ripristinare il proprio account col tasto qui sotto per scegliere un altro social di accesso.</p>
      <!--
      <b-button class="btn-login facebook" v-if="scelta == 'Facebook'" @click="login('Facebook')">
        <font-awesome-icon :icon="['fab', 'facebook']" />&nbsp;&nbsp;&nbsp;&nbsp;
        Facebook
      </b-button>
      -->
    </div>

    <!-- REGISTRAZIONE -->
    <div v-if="showRegistrazione">
      <h4 class="mt-4 text-success"><b>Attiva il tuo account!</b></h4>

      <p class="mt-4">
        Il tuo account non è ancora stato confermato, controlla la tua casella email PEC per attivare il tuo account.<br />
        Nel caso in cui il codice fiscale non corrisponda a un <b>avvocato iscritto nel REGINDE</b> non sarà possibile attivare l'account!
      </p>
    </div>

    <br/>
    <b-row>
      <b-col>
        <b-button class="mt-5" variant="outline-primary float-right" @click="showRipristina = !showRipristina">
          <font-awesome-icon icon="cog" />
          Ripristina account
        </b-button>
      </b-col>
      <b-col sm="0" md="3"></b-col>
    </b-row>
    <div>
      <b-card class="text-center mt-1" v-if="showRipristina">
        <div>
          <p>Col pulsante sottostante potrai ripristare il tuo account. <br/>
          Ti invieremo una PEC per farti riconfermare l'account e potrai decidere il tuo futuro metodo di accesso a GiustUp.</p>
          <b-button variant="primary" @click="ripristina()">
            Ripristina account
          </b-button>
        </div>
      </b-card>
    </div>
  </b-container>
</template>

<script>
import oauth from '../services/oauth.js'
import api from '../services/service.js'

export default {
  name: 'thankyou',
  data () {
    return {
      scelta: null,
      showRipristina: false,
      codFisc: null,
      showLogin: false,
      showRegistrazione: false
    }
  },
  methods: {
    async login(provider) {
      let prov = oauth.get(provider);
      
      prov.options.query.state.provider = provider;
      prov.options.query.state.redirect = this.$route.query.redirect;
      prov.options.query.state = JSON.stringify(prov.options.query.state);
      var uri = prov.code.getUri();

      location.href = uri;
    },
    ripristina() {
      let data = {'codfisc': this.$route.query.codfisc};

      api.execute('post', 'utente/ripristina', data, true).then((data) => {
        if(data.status === 200) // ok può fare login
        {
          this.showLogin = false;
          this.showRegistrazione = true;
          alert('Ti arriverà a breve una PEC con un link per associare un account social per eseguire il login.');
        }
      });
    },
    async checkLogged(){
      let data = await api.execute('get', 'oauth');
      return data;
    }
  },
  async created() {
    let parameters = this.$route.query;
    let logged = await this.checkLogged();
    if(logged) {
      this.$router.push({name: "Search"});
    }
    else if (parameters.codfisc === undefined || parameters.codfisc === "") {
      //TODO: change redirect to something appropriate 
      //TODO: figure out how to redirect to another component
      // location.href = "https://google.com"
      //FIXME: use the line below
      this.$router.push({name: "Home"});
      // location.href = "https://landing.giustup.it/";
    }
    else {
      let body = {
        'codfisc': parameters.codfisc,
        'source': parameters.utm_source
      };
      
      let data = await api.execute('post', 'utente/provider', body, true);
      this.codFisc = parameters.codfisc.toUpperCase();
      if(data.status === 200) // ok può fare login
      {
        this.scelta = data.data;
        this.showLogin = true;
      }
      else if(data.status === 201) // appena registrato
      {
        this.showRegistrazione = true;
      }
      else if(data.status === 204) // non attivo
      {
        this.showRegistrazione = true;
      }

      this.$parent._data.loaded = true;
    }
  }
}
</script>

<style>
@import './social.css';
</style>



// WEBPACK FOOTER //
// src/components/ThankYou.vue